'use client';

import type { Screenshot } from "@api/applications/general";

import { MediaGallery, MediaGalleryAsset } from "@ui/uikit/components/common/MediaGallery";

import styles from './ScreenshotsApplicationDetailsPageSection.module.scss';

interface ScreenshotsApplicaitonDetailsPageSectionProps {
  screenshots: Array<Screenshot>;
}

const ScreenshotsApplicationDetailsPageSection = ({ screenshots }: ScreenshotsApplicaitonDetailsPageSectionProps) => {
  return (
    <div className={styles['screenshots']}>
      {screenshots && screenshots.length > 0 && (
        <MediaGallery
          slideAspectRatio={1400 / 642}
          loading="eager"
          breakpoints={{
            SMALL: {
              numberOfSlides: 1,
              spacing: '8px',
              contentPadding: 16,
            },
            MEDIUM: {
              numberOfSlides: 2,
              spacing: '8px',
              contentPadding: 16,
            },
            LARGE: {
              numberOfSlides: 2,
              spacing: '16px',
              contentPadding: 16,
            },
            XLARGE: {
              numberOfSlides: 3,
              spacing: '16px',
              // contentPadding: 32,
            },
          }}
        >
          {screenshots.map(({ file }, index) => {
            return (
              <MediaGalleryAsset
                type="image"
                url={file}
                loading={index < 3 ? 'eager' : 'lazy'}
                key={file}
              />
            );
          })}
        </MediaGallery>
      )}
    </div>

  );
}

export {
  ScreenshotsApplicationDetailsPageSection,
}
